import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { openContentPopup } from "../../../../store/actions";

import { treasures } from "../../../../assets/images/treasures";

interface IProps {
  header?: string;
  text?: string;
  amount?: number;
  footer?: string;
  imageCode: number;
}

const mapDispatchToProps = (dispatch: any) => ({
  openContentPopupDispatch:
    (contentPopupOptions: any) => dispatch(openContentPopup(contentPopupOptions))
});

const connector = connect(null, mapDispatchToProps);

const LabyrinthResult = ({
  header,
  text,
  amount,
  footer,
  imageCode,
  openContentPopupDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <>
    <h2 className="h2 h2-first">
    <span className="bordered">{header}</span>
  </h2>
    <span className="divider"/>
    <span className="divider"/>
    <section className="boxes-group">
      <div className="box">
        <p className="text-center">
          <img src={treasures[`treasure${imageCode}`]} alt=""/>
        </p>
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2 text-info text-info-bigger">
            <p className="text-center">{text}
              <strong><em>{` ${amount} `}</em></strong>{footer}
            </p>
          </div>
        </div>
      </div>
      <div className="box">
        <p className="text-center">
          <a
            href="#"
            className="btn btn-blank btn-no-width"
            onClick={() => openContentPopupDispatch({
              name: "Labyrinth",
              title: "Labyrinth",
              icon: "labyrint"
            })}
          >
            Leave labyrinth
          </a>
        </p>
      </div>
      <span className="divider"/>
    </section>
  </>
)

export default connector(LabyrinthResult);
